export const isInPaytm = () => {
    const ua = window.navigator.userAgent;
    return /AppContainer/i.test(ua);
};
